import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBadge from "./CustomBadge";
import isEqual from "lodash.isequal";
import "assets/stylesheets/UgCoursesList.scss";

const getUrlForCourse = (c, inst) => {
  var baseUrl = "https://uac.edu.au/course-search/search/undergraduate/course/";
  var arr = [baseUrl, c.gCode];
  return arr.join("");
};

class UgCoursesList extends Component {
  constructor(props) {
    super(props);
    this.headingRef = React.createRef();
  }

  getHeading = () => {
    const { inst } = this.props;
    return `Courses at ${inst.name}`;
  };

  componentDidMount = () => {
    this.scrollToSelf();
  };

  componentDidUpdate = (prevProps) => {
    const { inst: prevInst } = prevProps;
    const { inst } = this.props;
    if (isEqual(inst, prevInst)) {
      return;
    } else {
      this.scrollToSelf();
    }
  };

  scrollToSelf = () => {
    document
      .getElementById("ug-courses-container")
      .scrollIntoView({ behavior: "smooth" });
    this.headingRef.current.focus({ preventScroll: true });
  };

  render() {
    const { inst, coursesByInstitution } = this.props;
    const courses = coursesByInstitution[inst.key] || [];
    return (
      <div id="ug-courses-container" className="section">
        <div id="ug-courses-heading">
          <h2
            className="major-heading"
            tabIndex={0}
            aria-label={`${this.getHeading()} ${courses.length} courses`}
            ref={this.headingRef}
          >
            {this.getHeading()}
          </h2>
          <CustomBadge count={courses.length} />
        </div>
        <p>Select a course to go to the course description.</p>
        {courses.map((course, i) => {
          return (
            <CourseLink
              key={course.courseCode}
              course={course}
              inst={this.props.inst}
              firstLink={i === 0}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { coursesByInstitution } = store.coursesByInstitutionReducer;
  return {
    coursesByInstitution,
  };
};

export default connect(mapStateToProps)(UgCoursesList);

class CourseLink extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }


  render() {
    const { course, inst } = this.props;
    return (
      <a
        href={getUrlForCourse(course, inst)}
        target="_blank"
        rel="noopener noreferrer"
        ref={this.ref}
        className="ug-course__container"
      >
        <div className="ug-course__name">{course.name}</div>
        <div className="ug-course__code">{course.courseCode}</div>
        <div className="sr-only">Opens in a new tab</div>
      </a>
    );
  }
}
